@if (sentimentTrends) {
<div class="sentiment-trends-section">
  <h3>{{ title || 'Sentiment Trends Analysis' }}</h3>
  <div class="trends-grid">
    <!-- Positive Aspects -->
    @if (sentimentTrends.positive_aspects && sentimentTrends.positive_aspects.length > 0) {
    <div class="trend-category positive">
      <h4>
        <mat-icon>thumb_up</mat-icon>
        Positive Aspects
      </h4>
      <ul>
        @for (aspect of sentimentTrends.positive_aspects; track aspect) {
        <li>{{ aspect }}</li>
        }
      </ul>
    </div>
    }

    <!-- Negative Aspects -->
    @if (sentimentTrends.negative_aspects && sentimentTrends.negative_aspects.length > 0) {
    <div class="trend-category negative">
      <h4>
        <mat-icon>thumb_down</mat-icon>
        Negative Aspects
      </h4>
      <ul>
        @for (aspect of sentimentTrends.negative_aspects; track aspect) {
        <li>{{ aspect }}</li>
        }
      </ul>
    </div>
    }

    <!-- Neutral Aspects -->
    @if (sentimentTrends.neutral_aspects && sentimentTrends.neutral_aspects.length > 0) {
    <div class="trend-category neutral">
      <h4>
        <mat-icon>thumbs_up_down</mat-icon>
        Neutral Aspects
      </h4>
      <ul>
        @for (aspect of sentimentTrends.neutral_aspects; track aspect) {
        <li>{{ aspect }}</li>
        }
      </ul>
    </div>
    }
  </div>
</div>
}
